import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LayoutActions from './layout.actions';

@Injectable()
export class LayoutEffects {

}